import { render } from "./FileUploadModal.vue?vue&type=template&id=bb824280&scoped=true"
import script from "./FileUploadModal.vue?vue&type=script&lang=js"
export * from "./FileUploadModal.vue?vue&type=script&lang=js"

import "./FileUploadModal.vue?vue&type=style&index=0&id=bb824280&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb824280"]])

export default __exports__